(function ($) {
    'use strict';

    function log (...args) {
        if (typeof window !== 'undefined' && window.adw && (window.adw.ENVIRONMENT || '').toLowerCase() !== 'production') {
            console.log(...args);
        }
    }

    log( 'pre defining awLoadAds function with JS file' );

    window.awLoadAds = function( options ){
        log( 'awLoadAds', 'from awLoadAds' );
        options = options || { usePersonalizedAds: true };
        const isReload = typeof window.awAdsLoaded !== 'undefined';
        const shouldRun = !isReload || (options && options.refresh);

        if (shouldRun) {
            if (adw && adw.ad_show_ads !== 'No') {
                if (!isReload) {
                    window.awAdsLoaded = true;
                }

                const utmVars = [
                    'utm_source',
                    'utm_medium',
                    'utm_campaign',
                    'utm_term',
                    'utm_content'
                ];

                const utmVarsTargeting = [];

                utmVars.forEach( function( utmVarName ){
                    const utmVarValue = getParameterByName( utmVarName );
                    if ( utmVarValue ){
                        utmVarsTargeting.push({
                            utmVarName: utmVarName,
                            utmVarValue: utmVarValue
                        });
                    }
                } );

                if( adw.ad_remove_data_eager ){
                    const adUnits = $( '.htl-ad-wrapper [data-eager], .ad-unit-t [data-eager], .ad-unit-a [data-eager], [class*="ad-unit-m"] [data-eager]' );
                    adUnits.removeAttr( 'data-eager' );
                }

                window.htlbid = window.htlbid || {};
                htlbid.cmd = htlbid.cmd || [];

                htlbid.cmd.push(function() {
                    htlbid.layout('universal');
                    htlbid.setTargeting( 'is_testing', ( adw.ENVIRONMENT === 'production' || adw.ENVIRONMENT === 'staging' || adw.ENVIRONMENT === 'qa' ) ? 'no' : 'yes' );
                    htlbid.setTargeting( 'is_home', ( adw.ad_zone === 'Homepage' || ( typeof window !== 'undefined' && ( window.location.pathname === '/' || window.location.pathname === '' ) ) ) ? 'yes' : 'no' );
                    htlbid.setTargeting( 'term', adw.ad_post_categories ? adw.ad_post_categories : '' );
                    htlbid.setTargeting( 'category', adw.ad_post_categories ? adw.ad_post_categories : '' );
                    htlbid.setTargeting( 'zone', adw.ad_zone ? adw.ad_zone : '' );

                    if (adw && adw.post && adw.post.ID) {
                        htlbid.setTargeting( 'page', adw.post.ID );
                        htlbid.setTargeting( 'post_id', adw.post.ID );
                    }

                    if (typeof htlbid.setRequestNonPersonalizedAds === 'function') {
                        if (options.usePersonalizedAds === true) {
                            htlbid.setRequestNonPersonalizedAds(0);
                        } else {
                            htlbid.setRequestNonPersonalizedAds(1);
                        }
                    }

                    if ( utmVarsTargeting && utmVarsTargeting.length > 0 ){
                        utmVarsTargeting.forEach( function( utmVar ){
                            htlbid.setTargeting( utmVar.utmVarName, utmVar.utmVarValue );
                        } );
                    }

                    if (window.location.href.indexOf('presentation=on') > -1) {
                        htlbid.setTargeting('presentation', 'on');
                    }

                    log( 'before htl ad occupied' );
                    if (htlbid.on) {
                        htlbid.on('occupied', function(slot) {
                            const div = jQuery( '#' + slot.getId() );
                            log( 'adding htl ad occupied' );
                            div.addClass( 'htl-ad-occupied' );

                            if ( div.hasClass( 'htl-ad-occupied' ) ){
                                if ( div.hasClass( 'aw-ad-unit-m1' ) && div.height() < 600 ){
                                    div.css( { 'min-height': 'auto' } );
                                }
                                if (div.hasClass('aw-ad-unit-t') && div.height() < 300) {
                                    div.css({ 'min-height': 'auto' });
                                }
                            }
                        });
                    }

                    if (htlbid.on) {
                        htlbid.on('empty', function(slot) {
                            const div = document.getElementById(slot.getId());
                            try{
                                const adWrapper = div.parentNode.parentNode.parentNode;
                                if ( adWrapper.className.indexOf( 'mobile-ad' ) > -1 ){
                                    adWrapper.classList.add( 'htl-ad-empty' );
                                }
                            } catch (err) { /* noop */ }
                        });
                    }
                });
            } else {
                return function () { /* noop */ };
            }
        }
    };

    document.addEventListener('DOMContentLoaded', function () {
        function serialize (obj = {}) {
            return Object.keys(obj).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(obj[ k ])).join('&');
        }

        const adslot = {};
        adslot.pubId = '319737315';
        adslot.site = 'adweek';
        adslot.prop = '/' + adslot.pubId + '/' + adslot.site + '/';

        const gptData = (typeof window !== 'undefined' && window.gptData) || {};
        adslot.zone = gptData.zone;
        adslot.postid = gptData.id;
        adslot.term = gptData.posttags;
        adslot.debug = gptData.debug === '1' ? 'True' : 'False';

        adslot.sizes = [];
        adslot.collection = [];

        adslot.presentation = gptData.presentation;
        adslot.referrer = document.referrer.replace(/http[s]?\:\/\/( [^\/]+ ).*/, "$1");

        const custParams = {
            term: adslot.term,
            debug: adslot.debug,
            page: adslot.postid,
            vid_width: '640',
            vid_height: '480',
            vid_id: '__item-mediaid__',
            vid_domain: '__domain__',
            vid_url: '__referrer__',
            vid_file: '__item-file__',
            vid_secs: '__item-duration__',
            vid_title: '__item-title__',
            vid_desc: '__item-description__',
            vid_auto: 'no',
            vid_muted: 'no'
        };

        const attrs = {
            sz: '640x480',
            iu: '/319737315/adweek',
            impl: 's',
            gdfp_req: 1,
            env: 'vp',
            output: 'vast',
            unviewed_position_start: 1,
            plcmt: (adslot.presentation || '').toLowerCase() === 'on' || window.location.href.indexOf('presentation=on') > -1 ? 1 : 2,
            url: window.location.href,
            description_url: window.location.href,
            correlator: Math.floor(Math.random() * 99999999),
            ad_rule: 1,
            cust_params: serialize(custParams)
        };

        window.jwpAdTag = 'https://pubads.g.doubleclick.net/gampad/ads?' + serialize(attrs);
    }, { once: true });
})(jQuery);
